import { Operation } from "rfc6902/diff";
import {
	CreateBlueprintInfo,
	createBlueprint,
	getBlueprintContent,
	updateBlueprintContent
} from "../base/BlueprintService";
import { InformationBlueprint } from "./InformationBlueprintTypes";

const DASHBOARD_BLUEPRINT_SUFFIX = "information";

export function createInformationBlueprint(
	info: CreateBlueprintInfo
): Promise<string> {
	return createBlueprint(DASHBOARD_BLUEPRINT_SUFFIX, info);
}

export function getInformationBlueprintContent(
	id: number
): Promise<InformationBlueprint> {
	return getBlueprintContent<InformationBlueprint>(
		DASHBOARD_BLUEPRINT_SUFFIX,
		id
	);
}

export function updateInformationBlueprintContent(
	id: number,
	content: Operation[]
): Promise<void> {
	return updateBlueprintContent(DASHBOARD_BLUEPRINT_SUFFIX, id, content);
}
